module.exports = __webpack_public_path__ + "img/Notification Icon - white.381e839e.svg";